// src/services/appInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

console.log('Application Insights Environment:', process.env.NODE_ENV);

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY,
    enableAutoRouteTracking: true, // Automatically track route changes
    enableCorsCorrelation: true,   // Track calls to your backend API
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    disableFetchTracking: false,   // Track fetch requests
    enableAjaxErrorStatusText: true,
    enableAjaxPerfTracking: true,
  }
});

// Only initialize in production
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY) {
    console.log('Initializing Application Insights...');
    appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags["ai.cloud.role"] = "React Frontend";
  });
  // Test tracking immediately
  appInsights.trackEvent({
    name: 'AppInsightsInitialized',
    properties: {
      timestamp: new Date().toISOString(),
      environment: process.env.NODE_ENV
    }
  });
  
  console.log('Application Insights initialized successfully');
}else {
    console.log('Application Insights NOT initialized - missing key or not production');
  }

export { appInsights };